import { ComponentType } from 'react';
import { connect } from 'react-redux';
import { Props } from './CollectNotification';
import { CollectionStoreState, actions } from '../redux';
import { getCollection } from '../redux/selectors';
import { getCurrentUser } from '../../publicSession/selectors';
import { addNotificationToQueue } from '../../Notifications/redux/actionCreators';

export type StateProps = Pick<Props, 'exampleCollection' | 'currentUser'>;
export type DispatchProps = Pick<Props, 'onUndo' | 'addNotification'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps = (state: CollectionStoreState, ownProps: OwnProps): StateProps => {
  return {
    exampleCollection: ownProps.exampleCollectionId
      ? getCollection(state, ownProps.exampleCollectionId)
      : undefined,
    currentUser: getCurrentUser(state),
  };
};

const mapDispatchToProps: DispatchProps = {
  onUndo: actions.undoChanges,
  addNotification: addNotificationToQueue,
};

const connector = connect(mapStateToProps, mapDispatchToProps) as (
  component: ComponentType<Props>
) => ComponentType<OwnProps>;

export default connector;
